import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

import userReducer from "./redux/reducers/user";
import DashboardReducer from "./redux/reducers/dashboard";
import taxPayerReducer from "./redux/tax-payer/tax-payer-slice";
import taxPayerPermissionsReducer from "./redux/tax-payer-permissions/tax-payer-permissions-slice";
import taxPayerParametersReducer from "./redux/tax-payer-parameters/tax-payer-parameters-slice";
import limitUsageReducer from "./redux/limit-usage/limit-usage-slice";
import systemNotificationsReducer from "./redux/system-notifications/system-notifications-slice";

const rootReducer = combineReducers({
  user: userReducer,
  dashboard: DashboardReducer,
  taxPayer: taxPayerReducer,
  taxPayerPermissions: taxPayerPermissionsReducer,
  taxPayerParameters: taxPayerParametersReducer,
  limitUsage: limitUsageReducer,
  systemNotifications: systemNotificationsReducer,
});

const middleware = [thunk];

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export type RootState = ReturnType<typeof rootReducer>;
export default store;
